import {CircularProgress, Typography} from "@material-ui/core";
import React from "react";

export default function Loading({visible = true}) {
    return (
        <div className="p-6 d-flex justify-content-center">
            <div className="text-center p-10" style={{width: '50%'}}>
                <CircularProgress className={`m-2`} color="secondary" size={30}/>
                <Typography className="mt-1" variant="subtitle1" component="h6" color="secondary">
                    Loading
                </Typography>
            </div>
        </div>
    );
}
